import { Navigate } from '@sorare/routing';
import { ANY_SPORT_SERIES_ONBOARDING_SELECT_TEAM_SLUG } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const OnboardingPage = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_SERIES_ONBOARDING_SELECT_TEAM_SLUG,
        {
          params: { slug: 'nba' },
        }
      )}
      replace
    />
  );
};
export default OnboardingPage;
